const mailSubjects = [
    'W nawiązaniu do naszej rozmowy – przesyłam szczegóły',
    'Zgodnie z ustaleniami telefonicznymi – komplet informacji',
    'Podsumowanie dzisiejszej rozmowy telefonicznej',
    'Przesyłam obiecane materiały z rozmowy',
    'Kontynuacja rozmowy telefonicznej – szczegóły w załączniku',
    'Przekazuję informacje zgodne z naszą rozmową',
    'Ustalenia z rozmowy – dokumenty w załączniku',
    'Informacje, o których rozmawialiśmy telefonicznie',
    'Materiały po naszej rozmowie telefonicznej',
    'Zgodnie z rozmową – przesyłam szczegółową ofertę',
    'Podsumowanie rozmowy – szczegóły do wglądu',
    'Dokumenty obiecane podczas rozmowy telefonicznej',
    'Zgodnie z ustaleniami przesyłam materiały',
    'Zapraszam do zapoznania się z materiałami po rozmowie',
    'Ważne szczegóły z dzisiejszej rozmowy telefonicznej',
    'Obiecane informacje po dzisiejszej rozmowie',
    'Rozmowa telefoniczna – dalsze kroki w załączniku',
    'Przesyłam podsumowanie naszych ustaleń',
    'Materiały zgodne z naszą rozmową telefoniczną',
    'Dalszy ciąg rozmowy telefonicznej – informacje w środku',
    'Podsumowanie ustaleń telefonicznych',
    'Obiecane szczegóły z naszej rozmowy telefonicznej',
    'Materiały po naszej dzisiejszej rozmowie',
    'Przesyłam dokumentację ustaleń telefonicznych',
    'Zgodnie z rozmową – informacje w załączniku',
]

const templates = {
    pan: {
        powitanie: [
            'Dzień dobry Panie {IMIĘ}!',
            'Witam serdecznie Panie {IMIĘ}!',
            'Szanowny Panie {IMIĘ},',
            'Panie {IMIĘ}, dzień dobry!',
            'Serdecznie witam, Panie {IMIĘ}!',
            'Panie {IMIĘ}, witam serdecznie!',
            'Szanowny Panie {IMIĘ}, witam Pana serdecznie!',
            'Witam Pana, Panie {IMIĘ}!',
        ],
        bezImienia: [
            'Dzień dobry!',
            'Witam serdecznie!',
            'Szanowny Panie,',
            'Szanowny Panie, witam serdecznie!',
        ],
        nastepneSzkolenie: [
            (tytul, link, data) =>
                `Po naszej rozmowie telefonicznej znalazłem dla Pana także szkolenie "${tytul}", które odbędzie się ${data}. Jest ono często wybierane przez inne urzędy, a zagadnienia zostały przygotowane w odpowiedzi na praktyczne pytania zgłaszane przez urzędników. Zapraszam do zapoznania się ze szczegółami: ${link}`,

            (tytul, link, data) =>
                `Zgodnie z tym, o czym rozmawialiśmy, proponuję również szkolenie "${tytul}" (termin: ${data}). Tematyka odpowiada na problemy i pytania najczęściej zgłaszane przez innych urzędników. Zachęcam, aby sprawdził Pan, czy to szkolenie będzie przydatne dla Państwa urzędu: ${link}`,

            (tytul, link, data) =>
                `Podczas rozmowy wspomniałem o szkoleniu "${tytul}", które odbędzie się ${data}. To popularne szkolenie, którego zakres został przygotowany w oparciu o potrzeby zgłaszane przez osoby zajmujące się tym tematem na co dzień. Proszę zapoznać się ze szczegółowym programem tutaj: ${link}`,

            (tytul, link, data) =>
                `Po rozmowie telefonicznej wybrałem dla Pana szkolenie "${tytul}", zaplanowane na ${data}. Program szkolenia jest tworzony na podstawie pytań i problemów zgłaszanych przez inne urzędy, co może być wartościowe również w Państwa przypadku. Zapraszam do sprawdzenia szczegółów: ${link}`,

            (tytul, link, data) =>
                `W odpowiedzi na naszą wcześniejszą rozmowę polecam szkolenie "${tytul}", które odbędzie się ${data}. Jest to jedno z częściej wybieranych przez urzędy szkoleń, ponieważ jego treść jest efektem pytań zadawanych przez osoby, które codziennie mają do czynienia z tym tematem. Szczegóły dostępne są pod tym linkiem: ${link}`,

            (tytul, link, data) =>
                `Warto również rozważyć szkolenie "${tytul}", które odbędzie się ${data}. Jest ono regularnie wybierane przez urzędy, a program obejmuje realne pytania urzędników zajmujących się tą tematyką. Zachęcam do zapoznania się z opisem: ${link}`,

            (tytul, link, data) =>
                `Dodatkowo proponuję szkolenie "${tytul}", zaplanowane na ${data}. Treści omawiane podczas spotkania są wynikiem problemów zgłaszanych przez innych urzędników, co może być przydatne również dla Państwa. Sprawdź szczegóły tutaj: ${link}`,

            (tytul, link, data) =>
                `Znalazłem jeszcze szkolenie "${tytul}", które odbędzie się ${data}. To popularna propozycja wśród urzędów, ponieważ porusza zagadnienia wynikające z codziennej pracy osób odpowiedzialnych za ten temat. Zapraszam do zapoznania się ze szczegółowym programem: ${link}`,
        ],
        dodatkowePytania: [
            'Chętnie odpowiem na wszelkie pytania.',
            'Zapraszam do kontaktu w razie dodatkowych pytań.',
            'Chętnie udzielę dodatkowych informacji gdyby pojawiły się jakieś pytania.',
            'Chętnie odpowiem na wszelkie pytania.',
            'W razie dodatkowych pytań, proszę o kontakt.',
            'W razie jakichkolwiek pytań pozostaję do dyspozycji.',
            'Zapraszam do kontaktu, jeśli ma Pan do mnie jakiekolwiek pytania dotyczące tych szkoleń.',
            'Zapraszam do kontaktu w razie dodatkowych pytań.',
            'Chętnie udzielę dodatkowych informacji.',
            'Jeśli ma Pan dodatkowe pytania, proszę śmiało się kontaktować – z przyjemnością pomogę.',
        ],
        pozegnanie: [
            'Pozdrawiam serdecznie,\nMarcin Skorupa',
            'Z wyrazami szacunku,\nMarcin Skorupa',
            'Z poważaniem,\nMarcin Skorupa',
            'Życzę miłego dnia,\nMarcin Skorupa',
            'Dziękuję za poświęcony czas,\nMarcin Skorupa',
            'Z uszanowaniem,\nMarcin Skorupa',
            'Życzę owocnego dnia pracy,\nMarcin Skorupa',
            'Będę wdzięczny za odpowiedź,\nMarcin Skorupa',
            'Pozostaję do dyspozycji,\nMarcin Skorupa',
        ],
        klauzula: [
            'Mam dla Pana ważną uwagę – może mi Pan bardzo pomóc, wpisując w polu „Uwagi” podczas rejestracji moje imię i nazwisko: Marcin Skorupa. Dziękuję za poświęcony czas i wsparcie!',

            'Będę wdzięczny, jeśli podczas rejestracji wpisze Pan w polu „Uwagi” moje imię i nazwisko: Marcin Skorupa. To dla mnie bardzo pomocne – dziękuję!',

            'Jeśli podczas rejestracji wpisze Pan w polu „Uwagi” moje imię i nazwisko: Marcin Skorupa, będzie mi niezmiernie miło. Dziękuję za pomoc!',

            'Mam do Pana drobną prośbę – jeśli to możliwe, proszę przy rejestracji wpisać w polu „Uwagi” moje imię i nazwisko: Marcin Skorupa. Będzie to dla mnie bardzo cenne wsparcie. Dziękuję!',

            'Podczas rejestracji w polu „Uwagi” może Pan wpisać moje imię i nazwisko: Marcin Skorupa. Bardzo mi to pomoże – z góry dziękuję!',

            'Jeżeli podczas rejestracji wpisze Pan w polu „Uwagi” moje imię i nazwisko: Marcin Skorupa, będzie mi bardzo miło. Dziękuję za pomoc i poświęcony czas!',

            'Chciałbym zwrócić Pana uwagę na ważny szczegół – wpisanie mojego imienia i nazwiska: Marcin Skorupa w polu „Uwagi” podczas rejestracji bardzo mi pomoże. Dziękuję!',

            'Jeśli będzie się Pan rejestrować, proszę o wpisanie w polu „Uwagi” mojego imienia i nazwiska: Marcin Skorupa. To dla mnie bardzo pomocne – dziękuję!',

            'Bardzo mi Pan pomoże, wpisując w polu „Uwagi” moje imię i nazwisko: Marcin Skorupa podczas rejestracji. Z góry dziękuję za wsparcie!',

            'Podczas rejestracji warto pamiętać o wpisaniu mojego imienia i nazwiska: Marcin Skorupa w polu „Uwagi” – to dla mnie duże wsparcie. Dziękuję serdecznie!',
        ],
        wiadomosc: [
            (tytul, link, data) =>
                `Nawiązując do naszej rozmowy, przesyłam Panu program szkolenia nt. "${tytul}", które odbędzie się ${data} w formie zdalnej.\n\n\nSzkolenie poprowadzi doświadczony praktyk, a szczegóły dostępne są pod tym linkiem: ${link}`,

            (tytul, link, data) =>
                `Tak jak wspominałem Panu podczas rozmowy, przesyłam szczegóły dotyczące szkolenia: "${tytul}", które planowane jest na ${data} w formie zdalnej.\n\n\nSzkolenie prowadzi doświadczony praktyk. Więcej informacji znajdzie Pan tutaj: ${link}`,

            (tytul, link, data) =>
                `Zgodnie z naszą rozmową, przesyłam Panu informacje o zdalnym szkoleniu pt. "${tytul}", które odbędzie się ${data}.\n\n\nProwadzącym będzie doświadczony praktyk, a wszystkie szczegóły znajdzie Pan tutaj: ${link}`,

            (tytul, link, data) =>
                `Dziękuję za rozmowę. W załączeniu przesyłam informacje o zdalnym szkoleniu "${tytul}", które odbędzie się ${data}.\n\n\nSzkolenie poprowadzi doświadczony praktyk. Szczegóły dostępne są pod tym linkiem: ${link}`,

            (tytul, link, data) =>
                `Jak wspominałem w rozmowie, trwa rekrutacja na zdalne szkolenie "${tytul}", które odbędzie się ${data}.\n\n\nProwadzącym będzie doświadczony praktyk, a szczegółowe informacje dostępne są pod linkiem: ${link}`,

            (tytul, link, data) =>
                `Przesyłam informacje na temat szkolenia "${tytul}", które odbędzie się ${data} w formie zdalnej, zgodnie z tym, o czym rozmawialiśmy.\n\n\nSzkolenie prowadzi doświadczony praktyk. Więcej informacji znajdzie Pan pod tym linkiem: ${link}`,

            (tytul, link, data) =>
                `Tak jak uzgodniliśmy w rozmowie, przesyłam szczegóły dotyczące szkolenia "${tytul}", które odbędzie się ${data} w formie zdalnej.\n\n\nProwadzi je doświadczony praktyk. Wszystkie szczegóły znajdzie Pan tutaj: ${link} `,

            (tytul, link, data) =>
                `Nawiązując do naszej rozmowy, chciałbym Panu przekazać szczegóły dotyczące zdalnego szkolenia "${tytul}", które odbędzie się ${data}.\n\n\nProwadzącym będzie doświadczony praktyk. Więcej informacji znajduje się tutaj: ${link}`,

            (tytul, link, data) =>
                `W nawiązaniu do rozmowy przesyłam Panu informacje dotyczące szkolenia "${tytul}", które odbędzie się ${data} w formie zdalnej.\n\n\nSzkolenie poprowadzi doświadczony praktyk. Szczegóły dostępne są pod tym linkiem: ${link}`,
        ],
    },
    pani: {
        powitanie: [
            'Dzień dobry Pani {IMIĘ}!',
            'Szanowna Pani {IMIĘ},',
            'Pani {IMIĘ}, dzień dobry!',
            'Serdecznie witam, Pani {IMIĘ}!',
            'Pani {IMIĘ}, witam serdecznie!',
            'Szanowna Pani {IMIĘ}, witam Panią serdecznie!',
            'Witam Panią, Pani {IMIĘ}!',
        ],

        bezImienia: [
            'Dzień dobry!',
            'Witam serdecznie!',
            'Szanowna Pani,',
            'Szanowna Pani, witam serdecznie!',
        ],
        nastepneSzkolenie: [
            (tytul, link, data) =>
                `Po naszej rozmowie telefonicznej znalazłem dla Pani szkolenie "${tytul}", które odbędzie się ${data}. Jest ono często wybierane przez inne urzędy, a zagadnienia zostały przygotowane w odpowiedzi na praktyczne pytania zgłaszane przez urzędników. Zapraszam do zapoznania się ze szczegółami: ${link}`,

            (tytul, link, data) =>
                `Zgodnie z tym, o czym rozmawiałyśmy, proponuję także szkolenie "${tytul}" (termin: ${data}). Tematyka odpowiada na problemy i pytania najczęściej zgłaszane przez innych urzędników. Zachęcam, aby sprawdziła Pani, czy to szkolenie będzie przydatne dla Państwa urzędu: ${link}`,

            (tytul, link, data) =>
                `Podczas rozmowy wspomniałem również o szkoleniu "${tytul}", które odbędzie się ${data}. To popularne szkolenie, którego zakres został przygotowany w oparciu o potrzeby zgłaszane przez osoby zajmujące się tym tematem na co dzień. Proszę zapoznać się ze szczegółowym programem tutaj: ${link}`,

            (tytul, link, data) =>
                `Po rozmowie telefonicznej wybrałem dla Pani szkolenie "${tytul}", zaplanowane na ${data}. Program szkolenia jest tworzony na podstawie pytań i problemów zgłaszanych przez inne urzędy, co może być wartościowe również w Państwa przypadku. Zapraszam do sprawdzenia szczegółów: ${link}`,

            (tytul, link, data) =>
                `W odpowiedzi na naszą wcześniejszą rozmowę polecam szkolenie "${tytul}", które odbędzie się ${data}. Jest to jedno z częściej wybieranych przez urzędy szkoleń, ponieważ jego treść jest efektem pytań zadawanych przez osoby, które codziennie mają do czynienia z tym tematem. Szczegóły dostępne są pod tym linkiem: ${link}`,

            (tytul, link, data) =>
                `Warto również rozważyć szkolenie "${tytul}", które odbędzie się ${data}. Jest ono regularnie wybierane przez urzędy, a program obejmuje realne pytania urzędników zajmujących się tą tematyką. Zachęcam do zapoznania się z opisem: ${link}`,

            (tytul, link, data) =>
                `Dodatkowo proponuję szkolenie "${tytul}", zaplanowane na ${data}. Treści omawiane podczas spotkania są wynikiem problemów zgłaszanych przez innych urzędników, co może być przydatne również dla Państwa. Sprawdź szczegóły tutaj: ${link}`,

            (tytul, link, data) =>
                `Znalazłem jeszcze szkolenie "${tytul}", które odbędzie się ${data}. To popularna propozycja wśród urzędów, ponieważ porusza zagadnienia wynikające z codziennej pracy osób odpowiedzialnych za ten temat. Zapraszam do zapoznania się ze szczegółowym programem: ${link}`,
        ],
        dodatkowePytania: [
            'Chętnie odpowiem na wszelkie pytania.',
            'Zapraszam Panią do kontaktu w razie dodatkowych pytań.',
            'Chętnie udzielę dodatkowych informacji gdyby pojawiły się jakieś pytania.',
            'Chętnie odpowiem na wszelkie pytania.',
            'W razie dodatkowych pytań, proszę o kontakt.',
            'W razie jakichkolwiek pytań pozostaję do Pani dyspozycji.',
            'Zapraszam do kontaktu, jeśli ma Pani do mnie jakiekolwiek pytania dotyczące tych szkoleń.',
            'Zapraszam do kontaktu w razie dodatkowych pytań.',
            'Chętnie udzielę dodatkowych informacji.',
            'Jeśli ma Pani dodatkowe pytania, proszę śmiało się kontaktować – z przyjemnością pomogę.',
        ],
        pozegnanie: [
            'Pozdrawiam serdecznie,\nMarcin Skorupa',
            'Z wyrazami szacunku,\nMarcin Skorupa',
            'Z poważaniem,\nMarcin Skorupa',
            'Życzę miłego dnia,\nMarcin Skorupa',
            'Dziękuję za poświęcony czas,\nMarcin Skorupa',
            'Z uszanowaniem,\nMarcin Skorupa',
            'Życzę owocnego dnia pracy,\nMarcin Skorupa',
            'Będę wdzięczny za odpowiedź,\nMarcin Skorupa',
            'Pozostaję do dyspozycji,\nMarcin Skorupa',
        ],
        klauzula: [
            'Mam dla Pani ważną uwagę – może mi Pani bardzo pomóc, wpisując w polu „Uwagi” podczas rejestracji moje imię i nazwisko: Marcin Skorupa. Dziękuję za poświęcony czas i wsparcie!',

            'Będę wdzięczny, jeśli podczas rejestracji wpisze Pani w polu „Uwagi” moje imię i nazwisko: Marcin Skorupa. To dla mnie bardzo pomocne – dziękuję!',

            'Jeśli podczas rejestracji wpisze Pani w polu „Uwagi” moje imię i nazwisko: Marcin Skorupa, będzie mi niezmiernie miło. Dziękuję za pomoc!',

            'Mam do Pani drobną prośbę – jeśli to możliwe, proszę wpisać w polu „Uwagi” moje imię i nazwisko: Marcin Skorupa. Będzie to dla mnie bardzo cenne wsparcie. Dziękuję!',

            'Podczas rejestracji w polu „Uwagi” może Pani wpisać moje imię i nazwisko: Marcin Skorupa. Bardzo mi to pomoże – z góry dziękuję!',

            'Jeżeli podczas rejestracji wpisze Pani w polu „Uwagi” moje imię i nazwisko: Marcin Skorupa, będzie mi bardzo miło. Dziękuję za pomoc i poświęcony czas!',

            'Chciałbym zwrócić Pani uwagę na ważny szczegół – wpisanie mojego imienia i nazwiska: Marcin Skorupa w polu „Uwagi” podczas rejestracji bardzo mi pomoże. Dziękuję!',

            'Jeśli będzie się Pani rejestrować, proszę o wpisanie w polu „Uwagi” mojego imienia i nazwiska: Marcin Skorupa. To dla mnie bardzo pomocne – dziękuję!',

            'Bardzo mi Pani pomoże, wpisując w polu „Uwagi” moje imię i nazwisko: Marcin Skorupa podczas rejestracji. Z góry dziękuję za wsparcie!',

            'Podczas rejestracji warto pamiętać o wpisaniu mojego imienia i nazwiska: Marcin Skorupa w polu „Uwagi” – to dla mnie duże wsparcie. Dziękuję serdecznie!',
        ],

        wiadomosc: [
            (tytul, link, data) =>
                `Nawiązując do naszej rozmowy, przesyłam Pani program szkolenia nt. "${tytul}", które odbędzie się ${data} w formie zdalnej.\n\n\nSzkolenie poprowadzi doświadczony praktyk, a szczegóły dostępne są pod tym linkiem: ${link}`,

            (tytul, link, data) =>
                `Zgodnie z naszą rozmową, przesyłam Pani szczegóły dotyczące szkolenia: "${tytul}", które odbędzie się ${data} w formie zdalnej.\n\n\nSzkolenie prowadzi doświadczony praktyk. Więcej informacji znajdzie Pani tutaj: ${link}`,

            (tytul, link, data) =>
                `Dziękuję za rozmowę. Przesyłam informacje o szkoleniu "${tytul}", które odbędzie się ${data} w formie zdalnej.\n\n\nSzkolenie poprowadzi doświadczony praktyk, a szczegóły znajdzie Pani pod tym linkiem: ${link}`,

            (tytul, link, data) =>
                `Tak jak uzgodniliśmy, przesyłam informacje o zdalnym szkoleniu "${tytul}", które odbędzie się ${data}.\n\n\nProwadzi je doświadczony praktyk. Szczegóły dostępne są tutaj: ${link}`,

            (tytul, link, data) =>
                `Nawiązując do naszej rozmowy, chciałbym przekazać Pani szczegóły dotyczące szkolenia "${tytul}", które odbędzie się ${data} w formie zdalnej.\n\n\nSzkolenie poprowadzi doświadczony praktyk. Więcej informacji znajdzie Pani pod tym linkiem: ${link}`,

            (tytul, link, data) =>
                `Przesyłam informacje na temat zdalnego szkolenia "${tytul}", które odbędzie się ${data}, zgodnie z tym, o czym rozmawialiśmy.\n\n\nSzkolenie prowadzi doświadczony praktyk. Szczegóły dostępne są pod linkiem: ${link}`,

            (tytul, link, data) =>
                `W nawiązaniu do rozmowy przesyłam szczegóły dotyczące szkolenia "${tytul}", które odbędzie się ${data} w formie zdalnej.\n\n\nProwadzącym będzie doświadczony praktyk. Więcej informacji znajdzie Pani tutaj: ${link}`,

            (tytul, link, data) =>
                `Tak jak rozmawialiśmy, przesyłam informacje dotyczące szkolenia "${tytul}", które odbędzie się ${data} w formie zdalnej.\n\n\nSzkolenie poprowadzi doświadczony praktyk. Szczegóły dostępne są tutaj: ${link}`,

            (tytul, link, data) =>
                `Dziękuję za rozmowę. Przesyłam informacje o szkoleniu "${tytul}", które odbędzie się ${data} w formie zdalnej.\n\n\nSzczegóły znajdzie Pani pod tym linkiem: ${link}`,

            (tytul, link, data) =>
                `Tak jak ustaliliśmy telefonicznie, zachęcam do zapoznania się z programem zdalnego szkolenia "${tytul}", które odbędzie się ${data}.\n\n\nProwadzącym będzie doświadczony praktyk. Szczegóły znajdzie Pani tutaj: ${link}`,
        ],
    },
    panstwo: {
        powitanie: [
            'Dzień dobry Państwu!',
            'Witam Państwa serdecznie!',
            'Szanowni Państwo,',
            'Witam Państwa uprzejmie!',
        ],
        bezImienia: ['Szanowni Państwo,', 'Dzień dobry!', 'Witam serdecznie!'],
        nastepneSzkolenie: [
            (tytul, link, data) =>
                `Po naszej rozmowie telefonicznej znalazłem dla Państwa szkolenie "${tytul}", które odbędzie się ${data}. Jest ono często wybierane przez inne urzędy, a zagadnienia zostały przygotowane w odpowiedzi na praktyczne pytania zgłaszane przez urzędników. Zapraszam do zapoznania się ze szczegółami: ${link}`,

            (tytul, link, data) =>
                `Zgodnie z tym, o czym rozmawialiśmy, proponuję szkolenie "${tytul}" (termin: ${data}). Tematyka odpowiada na problemy i pytania najczęściej zgłaszane przez inne urzędy. Zachęcam, aby sprawdzili Państwo, czy to szkolenie będzie przydatne dla Państwa urzędu: ${link}`,

            (tytul, link, data) =>
                `Podczas rozmowy wspomniałem o szkoleniu "${tytul}", które odbędzie się ${data}. To popularne szkolenie, którego zakres został przygotowany w oparciu o potrzeby zgłaszane przez osoby zajmujące się tym tematem na co dzień. Proszę zapoznać się ze szczegółowym programem tutaj: ${link}`,

            (tytul, link, data) =>
                `Po rozmowie telefonicznej wybrałem dla Państwa szkolenie "${tytul}", zaplanowane na ${data}. Program szkolenia jest tworzony na podstawie pytań i problemów zgłaszanych przez inne urzędy, co może być wartościowe również dla Państwa. Zapraszam do sprawdzenia szczegółów: ${link}`,

            (tytul, link, data) =>
                `W odpowiedzi na naszą wcześniejszą rozmowę polecam Państwu szkolenie "${tytul}", które odbędzie się ${data}. Jest to jedno z częściej wybieranych przez urzędy szkoleń, ponieważ jego treść jest efektem pytań zadawanych przez osoby, które codziennie mają do czynienia z tym tematem. Szczegóły dostępne są pod tym linkiem: ${link}`,

            (tytul, link, data) =>
                `Warto również rozważyć szkolenie "${tytul}", które odbędzie się ${data}. Jest ono regularnie wybierane przez urzędy, a program obejmuje realne pytania urzędników zajmujących się tą tematyką. Zachęcam Państwa do zapoznania się z opisem: ${link}`,

            (tytul, link, data) =>
                `Dodatkowo proponuję Państwu szkolenie "${tytul}", zaplanowane na ${data}. Treści omawiane podczas spotkania są efektem problemów zgłaszanych przez urzędy. Szczegóły znajdą Państwo tutaj: ${link}`,

            (tytul, link, data) =>
                `Znalazłem jeszcze szkolenie "${tytul}", które odbędzie się ${data}. Jest to popularna propozycja wśród urzędów, ponieważ porusza zagadnienia wynikające z codziennej pracy osób odpowiedzialnych za ten temat. Zapraszam Państwa do zapoznania się ze szczegółowym programem: ${link}`,
        ],
        dodatkowePytania: [
            'Chętnie odpowiem na wszelkie pytania.',
            'Zapraszam do kontaktu w razie dodatkowych pytań.',
            'Chętnie udzielę dodatkowych informacji gdyby pojawiły się jakieś pytania.',
            'Chętnie odpowiem na wszelkie pytania.',
            'W razie dodatkowych pytań, proszę o kontakt.',
            'W razie jakichkolwiek pytań pozostaję do Państwa dyspozycji.',
            'Zapraszam do kontaktu, jeśli mają Państwo do mnie jakiekolwiek pytania dotyczące tych szkoleń.',
            'Zapraszam do kontaktu w razie dodatkowych pytań.',
            'Chętnie udzielę dodatkowych informacji.',
            'Jeśli mają Państwo dodatkowe pytania, proszę śmiało się kontaktować – z przyjemnością pomogę.',
        ],
        pozegnanie: [
            'Pozdrawiam serdecznie,\nMarcin Skorupa',
            'Z wyrazami szacunku,\nMarcin Skorupa',
            'Z poważaniem,\nMarcin Skorupa',
            'Życzę miłego dnia,\nMarcin Skorupa',
            'Dziękuję za poświęcony czas,\nMarcin Skorupa',
            'Z uszanowaniem,\nMarcin Skorupa',
            'Życzę owocnego dnia pracy,\nMarcin Skorupa',
            'Będę wdzięczny za odpowiedź,\nMarcin Skorupa',
            'Pozostaję do dyspozycji,\nMarcin Skorupa',
        ],
        klauzula: [
            'Mam dla Państwa ważną uwagę – mogą mi Państwo bardzo pomóc, wpisując w polu „Uwagi” podczas rejestracji moje imię i nazwisko: Marcin Skorupa. Dziękuję za poświęcony czas i wsparcie!',

            'Będę wdzięczny, jeśli podczas rejestracji wpiszą Państwo w polu „Uwagi” moje imię i nazwisko: Marcin Skorupa. To dla mnie bardzo pomocne – dziękuję!',

            'Jeśli podczas rejestracji wpiszą Państwo w polu „Uwagi” moje imię i nazwisko: Marcin Skorupa, będzie mi niezmiernie miło. Dziękuję za pomoc!',

            'Mam do Państwa drobną prośbę – jeśli to możliwe, proszę wpisać w polu „Uwagi” moje imię i nazwisko: Marcin Skorupa. Będzie to dla mnie bardzo cenne wsparcie. Dziękuję!',

            'Podczas rejestracji w polu „Uwagi” mogą Państwo wpisać moje imię i nazwisko: Marcin Skorupa. Bardzo mi to pomoże – z góry dziękuję!',

            'Jeżeli podczas rejestracji wpiszą Państwo w polu „Uwagi” moje imię i nazwisko: Marcin Skorupa, będzie mi bardzo miło. Dziękuję za pomoc i poświęcony czas!',

            'Chciałbym zwrócić Państwa uwagę na ważny szczegół – wpisanie mojego imienia i nazwiska: Marcin Skorupa w polu „Uwagi” podczas rejestracji bardzo mi pomoże. Dziękuję!',

            'Jeśli będą Państwo się rejestrować, proszę o wpisanie w polu „Uwagi” mojego imienia i nazwiska: Marcin Skorupa. To dla mnie bardzo pomocne – dziękuję!',

            'Bardzo mi Państwo pomogą, wpisując w polu „Uwagi” moje imię i nazwisko: Marcin Skorupa podczas rejestracji. Z góry dziękuję za wsparcie!',

            'Podczas rejestracji warto pamiętać o wpisaniu mojego imienia i nazwiska: Marcin Skorupa w polu „Uwagi” – to dla mnie duże wsparcie. Dziękuję serdecznie!',
        ],
        wiadomosc: [
            (tytul, link, data) =>
                `Przesyłam Państwu program szkolenia nt. "${tytul}", które odbędzie się ${data}.\n\n\nSzczegóły znajdują się pod tym linkiem: ${link}`,
            (tytul, link, data) =>
                `Szanowni Państwo, w załączeniu przesyłam informacje na temat szkolenia "${tytul}", które odbędzie się ${data}. Dodatkowe szczegóły można znaleźć tutaj: ${link}`,
        ],
    },
    przypomnienie: {
        powitanie: [
            'Przypomnienie – {IMIĘ},',
            'Chciałem przypomnieć, {IMIĘ}.',
            'Szanowny Panie {IMIĘ}, pozwalam sobie przypomnieć.',
        ],
        wiadomosc: [
            (tytul, link, data) =>
                `Nawiązując do naszej rozmowy, przesyłam Państwu program szkolenia nt. "${tytul}", które odbędzie się ${data} w formie zdalnej.\n\n\nSzkolenie poprowadzi doświadczony praktyk, a szczegóły dostępne są pod tym linkiem: ${link}`,

            (tytul, link, data) =>
                `Zgodnie z naszą rozmową, przesyłam Państwu szczegóły dotyczące szkolenia: "${tytul}", które odbędzie się ${data} w formie zdalnej.\n\n\nSzkolenie prowadzi doświadczony praktyk. Więcej informacji znajdą Państwo tutaj: ${link}`,

            (tytul, link, data) =>
                `Dziękuję za rozmowę. Przesyłam informacje o szkoleniu "${tytul}", które odbędzie się ${data} w formie zdalnej.\n\n\nSzkolenie poprowadzi doświadczony praktyk, a szczegóły znajdą Państwo pod tym linkiem: ${link}`,

            (tytul, link, data) =>
                `Tak jak uzgodniliśmy, przesyłam informacje o zdalnym szkoleniu "${tytul}", które odbędzie się ${data}.\n\n\nProwadzi je doświadczony praktyk. Szczegóły dostępne są tutaj: ${link}`,

            (tytul, link, data) =>
                `Nawiązując do naszej rozmowy, chciałbym przekazać Państwu szczegóły dotyczące szkolenia "${tytul}", które odbędzie się ${data} w formie zdalnej.\n\n\nSzkolenie poprowadzi doświadczony praktyk. Więcej informacji znajdą Państwo pod tym linkiem: ${link}`,

            (tytul, link, data) =>
                `Przesyłam informacje na temat zdalnego szkolenia "${tytul}", które odbędzie się ${data}, zgodnie z tym, o czym rozmawialiśmy.\n\n\nSzkolenie prowadzi doświadczony praktyk. Szczegóły dostępne są pod linkiem: ${link}`,

            (tytul, link, data) =>
                `W nawiązaniu do rozmowy przesyłam szczegóły dotyczące szkolenia "${tytul}", które odbędzie się ${data} w formie zdalnej.\n\n\nProwadzącym będzie doświadczony praktyk. Więcej informacji znajdą Państwo tutaj: ${link}`,

            (tytul, link, data) =>
                `Tak jak rozmawialiśmy, przesyłam informacje dotyczące szkolenia "${tytul}", które odbędzie się ${data} w formie zdalnej.\n\n\nSzkolenie poprowadzi doświadczony praktyk. Szczegóły dostępne są tutaj: ${link}`,

            (tytul, link, data) =>
                `Dziękuję za rozmowę. Przesyłam informacje o szkoleniu "${tytul}", które odbędzie się ${data} w formie zdalnej.\n\n\nSzczegóły znajdą Państwo pod tym linkiem: ${link}`,

            (tytul, link, data) =>
                `Tak jak ustaliliśmy telefonicznie, zachęcam do zapoznania się z programem zdalnego szkolenia "${tytul}", które odbędzie się ${data}.\n\n\nProwadzącym będzie doświadczony praktyk. Szczegóły znajdą Państwo tutaj: ${link}`,
        ],
    },
}

export default templates
export { mailSubjects }
